import { render } from "./Corre.vue?vue&type=template&id=b5f06358"
import script from "./Corre.vue?vue&type=script&lang=js"
export * from "./Corre.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__